import React from 'react';
import AdminTeacherMap from '../domains/admin/components/AdminTeacherMap';

const AdminTeacherMapPage: React.FC = () => <AdminTeacherMap />;

export default AdminTeacherMapPage;
